import { useState } from 'react';
import { Button, IButtonProps } from '../button/button.component';
import { ConfirmModal, IConfirmModalDetailsProps } from './confirm-modal.component';

interface IConfirmProps
  extends IConfirmModalDetailsProps,
    Pick<IButtonProps, 'hideEndMargin' | 'icon' | 'loading' | 'size' | 'variant' | 'tooltip'> {
  buttonTitle: string;
  className?: string;
  skipConfirm?: boolean;
}

export const ConfirmButton = ({
  buttonTitle,
  className,
  icon,
  hideEndMargin,
  loading,
  size,
  skipConfirm,
  tooltip,
  variant,
  ...modalProps
}: IConfirmProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Button
        text={buttonTitle}
        className={className}
        onClick={() => (skipConfirm ? modalProps.onConfirm() : setIsOpen(true))}
        loading={loading}
        size={size}
        hideEndMargin={hideEndMargin}
        icon={icon}
        tooltip={tooltip}
        variant={variant}
      />
      <ConfirmModal {...modalProps} open={isOpen} onClose={closeModal} />
    </>
  );
};
